import React from 'react';
import SpreadReadingPage from './SpreadReadingPage';

const config = {
  pickerPage: 'newLove',
  path: '/new-love-tarot-reading/',
  spreadId: 'newLove',
  cardCount: 3,
  metaTitle: 'Free New Love Tarot Reading - Will I Find Love? | NowTarot AI',
  metaDescription:
    'Get a free new love tarot reading. Draw 3 cards to see how ready you are for love, where a new connection may appear, and what to overcome. 100% free, no signup.',
  metaKeywords:
    'new love tarot reading, will I find love tarot, single tarot reading, new relationship tarot, finding love tarot spread, free love tarot for singles',
  heading: 'New Love Tarot Reading',
  intro:
    'Single and wondering when love will find you? This free new love tarot reading uses a spread made for people seeking romance: three cards revealing how ready your heart is, where a new connection may appear, and what you need to overcome first. 100% free, no signup required.',
  howItWorks:
    'Think about the kind of love you want to welcome into your life, then shuffle the deck and pick three cards. The first card shows your readiness for new love, the second points to where or how a connection may appear, and the third names the challenge to work through so love can reach you.',
  contentSections: [
    {
      heading: 'The Three Positions of the New Love Spread',
      items: [
        {
          title: 'Your Readiness',
          text: 'How open you are to love right now. This card can reveal lingering hurt from the past, a guarded heart, or a confident, magnetic energy that is ready for something new.',
        },
        {
          title: 'Where Love Appears',
          text: 'Where or how a new romantic connection may show up: through friends, work, travel, a new hobby, or someone already in your life seen in a new light.',
        },
        {
          title: 'Challenges',
          text: 'The block to clear first. Often this is a habit, a fear, or an old pattern, such as choosing unavailable partners or not letting yourself be seen.',
        },
      ],
    },
    {
      heading: 'Cards to Watch For in a New Love Reading',
      items: [
        {
          title: 'Ace of Cups & Two of Cups',
          text: 'Classic signs of new love. The Ace of Cups is an open heart and fresh feelings; the Two of Cups is a mutual spark between two people.',
        },
        {
          title: 'Knight of Cups & Page of Cups',
          text: 'Romantic messengers. These cards often point to an invitation, a flirtatious message, or someone who leads with their feelings.',
        },
        {
          title: 'Eight of Cups & Five of Pentacles',
          text: 'Signs that something needs to be released or that you feel left out in the cold. They suggest healing and self-worth come before the right person arrives.',
        },
      ],
    },
  ],
  faqHeading: 'New Love Tarot FAQ',
  faq: [
    {
      question: 'Can tarot tell me when I will find love?',
      answer:
        'Tarot shows the energy around your love life now and the direction it is moving rather than an exact date. The new love spread focuses on readiness, where love may appear, and what to work on, which is usually more useful than a date.',
    },
    {
      question: 'How is this different from the love tarot reading?',
      answer:
        'Our love tarot reading looks at the past, present, and future of your love life and suits people in a relationship or a complicated situation. The new love reading is designed for people who are single and looking for someone new.',
    },
    {
      question: 'What questions should I ask in a new love reading?',
      answer:
        'Try "Am I ready for a new relationship?", "Where am I likely to meet someone?", or "What is blocking me from finding love?" For a quick answer like "Will I meet someone this year?", try our Yes or No tarot reading.',
    },
    {
      question: 'Is this new love tarot reading free?',
      answer:
        'Yes! This new love tarot reading is 100% free with no signup or credit card required. For deeper, personalized guidance, ask our AI tarot reader in chat.',
    },
  ],
  crossLinks: (
    <>
      Already with someone? Try the <a href="/love-tarot-reading/" style={{ color: '#FFD700' }}>love and relationships reading</a>, get a quick{' '}
      <a href="/yes-or-no-tarot/" style={{ color: '#FFD700' }}>Yes or No answer</a>, or explore{' '}
      <a href="/tarot-card-meanings/" style={{ color: '#FFD700' }}>the meaning of every tarot card</a> — all free, no signup required.
    </>
  ),
};

const NewLoveTarot = () => <SpreadReadingPage config={config} />;

export default NewLoveTarot;
